export default __webpack_public_path__ + "static/media/10_BGRY4F-min.8e88537c.jpg";